var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-page-header',{attrs:{"currentPage":_vm.currentPage,"headingTexts":_vm.headingTexts,"tabLinks":_vm.tabLinks,"tabOptions":_vm.tabOptions,"buttons":_vm.buttons,"isInvalid":_vm.isInvalid}})}
var staticRenderFns = []

export { render, staticRenderFns }